import script from "./shop-details-desc.vue?vue&type=script&setup=true&lang=js"
export * from "./shop-details-desc.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__